import { useCallback } from 'react'
import Formsy from 'formsy-react'
import PropTypes from 'prop-types'

import Select from '@components/Select/RequiredSelectWithFormsy'
import { withTranslate } from '@i18n/utils'

import { getStates, getStateValue } from 'shared/states'

import { stripDocumentNumber } from 'shared/components/DocumentDataFields/utils'
import DocumentDataFields from 'shared/components/DocumentDataFields'

import BoletoFormSimpleField from './BoletoFormSimpleField'
import { useBoletoFormTranslate } from './utils'
import { FIELD_CLASS_NAME } from './constants'

const BoletoForm = ({
    defaultFormData: { documentType, documentNumber, postalCode, street, streetNumber, district, city, state },
    translate,
    country = 'BR',
    onChange,
    onValid = () => {},
    onInvalid = () => {},
}) => {
    const { tLabel } = useBoletoFormTranslate(translate)

    const handleChange = useCallback(
        formData => {
            const formDataNormalized = {
                ...formData,
                documentNumber: stripDocumentNumber(formData.documentNumber),
            }
            onChange(formDataNormalized)
        },
        [onChange]
    )

    return (
        <Formsy onChange={handleChange} onValid={onValid} onInvalid={onInvalid}>
            <div className="row">
                <DocumentDataFields
                    documentNumber={documentNumber}
                    documentType={documentType}
                    fieldClassName={FIELD_CLASS_NAME}
                    isPurchaseFlow
                />
                <BoletoFormSimpleField name="postalCode" defaultValue={postalCode} />
            </div>
            <div className="row">
                <BoletoFormSimpleField name="street" defaultValue={street} />
                <BoletoFormSimpleField name="streetNumber" defaultValue={streetNumber} />
            </div>
            <div className="row">
                <BoletoFormSimpleField name="district" defaultValue={district} />
                <BoletoFormSimpleField name="city" defaultValue={city} />
            </div>
            <div className="row">
                <div className={`${FIELD_CLASS_NAME} mb-3`}>
                    <Select
                        options={getStates(country)}
                        isSearchable
                        getSelectValue={getStateValue(country)}
                        defaultValue={state}
                        name="state"
                        placeholder={tLabel('state')}
                        required
                    />
                </div>
            </div>
        </Formsy>
    )
}

BoletoForm.propTypes = {
    defaultFormData: PropTypes.shape({
        documentType: PropTypes.string,
        documentNumber: PropTypes.string,
        postalCode: PropTypes.string,
        street: PropTypes.string,
        streetNumber: PropTypes.string,
        district: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
    }),
    country: PropTypes.oneOf(['BR', 'CA', 'US']),
    onChange: PropTypes.func.isRequired,
    onValid: PropTypes.func,
}

export default withTranslate(BoletoForm)
